import { flattenValues } from "@uniformdev/canvas";

import { CustomerDetailsStats as CustomerStat } from "@/templates/customers/customers-details-page/customer-details-stats";

export type { CustomerDetailsStatProps as CustomerStatProps } from "@/templates/customers/customers-details-page/customer-details-stats";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenCustomerStatProps = (props: any) => {
    const statProps = { ...props };
    statProps.stats = flattenValues(props.stats);
    return statProps;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformCustomerStat = (props: any) => {
    const statProps = flattenCustomerStatProps(props);
    return <CustomerStat {...statProps} />;
};

export default UniformCustomerStat;
